<template>
    <div class="quit-wrapper">
        <div class="close-area" :class="{'mask': mask }"></div>
        <div class="quit-message">
            <div class="message-top">
                <div class="message-title">{{messageTitle}}</div>
                <div class="message-cancel" @click.stop="$emit('closeQuitWarning')">
                    <div class='top-cancel'></div>
                </div>
            </div>
            <div class="message-main">{{messageText}}</div>
            <div class="message-footer">
                <button class='footer-cancel' @click.stop="$emit('closeQuitWarning')">取消</button>
                <button class='footer-query' @click.stop="$emit('eventContinue')">{{queryBtn}}</button>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'quitMessage',
    data() {
        return {}
    },
    props: ['messageTitle', 'messageText', 'queryBtn','mask'],
    mounted() {
    },
    methods: {}
}
</script>
<style lang='scss' type="text/scss" scoped>
    .quit-wrapper {
        .close-area{
            position: fixed;
            top: 0;
            left: 0;
            bottom: 0;
            right: 0;
            z-index: 105;
            background: rgba(0, 0, 0, 0);
        }
        .mask{
            background: rgba(0, 0, 0, 0.3);
        }
        .quit-message {
            width: 100%;
            height: j(446);
            position: fixed;
            left: 0;
            bottom: 0;
            z-index: 1103;
            background: #fff;
            box-sizing: border-box;
            .message-top {
                height: j(120);
                font-size: j(32);
                color: #363C54;
                padding: j(40) j(50);
                display: flex;
                align-items: center;
                justify-content: space-between;
                box-sizing: border-box;

                .message-title {

                }

                .message-cancel {
                    width: j(88);
                    height: j(88);
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    .top-cancel {
                        width: j(3);
                        height: j(32);
                        position: relative;
                        background: #696D7F;
                        -webkit-transform: rotate(45deg);
                        -moz-transform: rotate(45deg);
                        -o-transform: rotate(45deg);
                        -ms-transform: rotate(45deg);
                        transform: rotate(45deg);
                        display: inline-block;

                        &:after {
                            content: "";
                            position: absolute;
                            top: 0;
                            left: 0;
                            width: j(3);
                            height: j(32);
                            background: #696D7F;
                            -webkit-transform: rotate(270deg);
                            -moz-transform: rotate(270deg);
                            -o-transform: rotate(270deg);
                            -ms-transform: rotate(270deg);
                            transform: rotate(270deg);
                        }
                    }
                }

            }

            .message-main {
                height: j(176);
                font-size: j(32);
                color: #040B29;
                padding: j(40) j(50);
                box-sizing: border-box;
            }

            .message-footer {
                height: j(150);
                display: flex;
                align-items: center;
                justify-content: space-around;
                border-top: j(2) solid #F0F1F2;

                .footer-cancel {
                    width: j(315);
                    height: j(90);
                    border-radius: j(45);
                    border: 1px solid #F0F1F2;
                    background: #fff;
                    font-size: j(32);
                    color: #696D7F;
                }

                .footer-query {
                    width: j(315);
                    height: j(90);
                    border-radius: j(45);
                    border: none;
                    background: #00BCBC;
                    font-size: j(32);
                    color: #fff;
                }
            }
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/quitMessage.vue